module.exports = __webpack_public_path__ + "img/46.94da0683.jpg";